import { Component, OnInit } from "@angular/core";
import { JsLoaderService } from "src/shared/services/js-loader.service";
import { AppConfig } from "../../app-config";


@Component({
  selector: 'app-travel-clearance',
  templateUrl: './travel-clearance.component.html'
})
export class TravelClearanceComponent implements OnInit {

  constructor(private jsLoader: JsLoaderService, private config: AppConfig) { }
  IsPortal = this.config.IsPortal;
  ATCPGuideVideoPath = this.config.ATCPGuideVideo;

  ngOnInit() {
    this.jsLoader.loadScripts();
    console.log(this.IsPortal);
  }

}
